import React from 'react'
import { Modal, Menu, List, message } from 'antd'
import { app, use, api } from 'xadmin'
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';

const findColums = (schema, prefix, columns) => {
  const properties = schema.properties || {}
  let keys = schema.form ? (
    schema.form.indexOf('*') >= 0 ?
      Object.keys(properties) : schema.form.map(f => typeof f == 'string' ? f : f.key)) :
    Object.keys(properties)

  keys = [...keys,
  ...Object.keys(properties)
    .filter(k => keys.indexOf(k) == -1 && properties[k].type == 'object')]
    .filter(k => k != 'model')

  keys.forEach(key => {
    const p = properties[key]
    if (!p) return

    if (p.type == 'object') {
      if (p.fieldType != undefined) {
        columns.push({
          title: prefix.title + p.title,
          name: prefix.name + (p.name || key),
          type: p.type
        })
      } else if (p.relateTo == undefined) {
        findColums(p, { title: p.title + '-', name: prefix.name + key + '.' }, columns)
      }
    } else if (p.type == 'array') {
      if (p.fieldType != undefined) {
        columns.push({
          title: prefix.title + p.title + '编号',
          name: prefix.name + (p.name || key),
          type: p.type, fieldType: p.fieldType
        })
      }
    } else {
      columns.push({
        title: prefix.title + p.title,
        name: prefix.name + (p.name || key),
        type: p.type
      })
    }
  });
  return columns
}

/* see Browser download file example in docs */
function s2ab(s/*:string*/)/*:ArrayBuffer*/ {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}

const BatchExportTags = props => {
  const { selected } = use('model.select', props)
  const { getSchema } = use('device.driver')
  const { addExporImportLog } = use('log.exporImport')

  const { model, filtersModel } = use('model', state => ({ filtersModel: state?.wheres?.filters?.model }))
  const driver = filtersModel?.device?.driver

  const onExport = React.useCallback(async () => {
    // 获取当前driver 数据点Schema 
    const tagsFields = await getSchema(driver, { model: true }).then(res => res?.properties?.tags?.items)
    // 导出数据点
    const wb = XLSX.utils.book_new()
    const columns = findColums(tagsFields, { title: '', name: '' }, [])

    selected.forEach(node => {
      const tags = _.get(node, 'device.tags')
      const rows = tags.map(tag => columns.map(item => _.get(tag, item.name)))
      const ws = XLSX.utils.aoa_to_sheet([columns.map(c => c.title), ...rows])
      XLSX.utils.book_append_sheet(wb, ws, `${node.name}`)
    })

    addExporImportLog && addExporImportLog({
      mode: 'export', data: selected,
      schema: {
        ...model,
        title: model?.title + "数据点导出"
      },
    })
    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' })
    /* send to client */
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${filtersModel?.name}资产数据点配置.xlsx`)
  }, [selected, model])

  return (
    <Menu.Item {...props} key={'actions_batch_export_tags'}
      onClick={(e) => {
        props.onClick && props.onClick(e)
        onExport()
      }} disabled={selected.length == 0}>
      批量导出数据点配置
    </Menu.Item>
  )

}

export default BatchExportTags
